<template>
  <BaseDropdown :class="['font-normal text-base font-roboto my-1 px-2',
                         'text-main-alt border-main-alt border-2 rounded-lg transition-opacity',
                         allDisabled ? ' border-opacity-30' : '']"
                icon="keyboard_arrow_down" menuText="Actions"
                menuY="translate-y-12" :disabled="allDisabled">
    <button class="text-sm" :disabled="archiveDisabled" @click="archive">
      {{ props.activeView ? "Archive" : "Un-Archive" }}
    </button>
  </BaseDropdown>
</template>

<script>
import BaseDropdown from "Components/ui/BaseDropdown.vue";
export default {
  name: "NoteEntryPoint",
  emits: ["archive-click"],
  components: { BaseDropdown },
  props: {
    props: Object
  },
  data () {
    return {};
  },
  computed: {
    archiveDisabled () {
      return this.props.selectedData.length == 0;
    },
    allDisabled () {
      return this.archiveDisabled; /* && otherDisabled */
    }
  },
  methods: {
    archive () {
      this.$emit("archive-click");
    },

  },
};
</script>
<style scoped></style>